import { render, staticRenderFns } from "./VerificationDialog.vue?vue&type=template&id=77247eba&scoped=true"
import script from "./VerificationDialog.vue?vue&type=script&lang=js"
export * from "./VerificationDialog.vue?vue&type=script&lang=js"
import style0 from "./VerificationDialog.vue?vue&type=style&index=0&id=77247eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77247eba",
  null
  
)

export default component.exports